<form [formGroup]="productoForm" (ngSubmit)="onSubmit()">
    <h2>Registro del Producto</h2>

    <!-- FACTURA 
    <div class="field">
        <label for="factura">Factura*</label>
        <input id="factura" type="text" formControlName="fk_factura"
            [ngClass]="{'input-error':getControl('fk_factura').touched && getControl('fk_factura').invalid}" />
        <small class="error" *ngIf="getControl('fk_factura').touched && getControl('fk_factura').invalid">
            <span *ngIf="getControl('fk_factura')?.hasError('required')">
                Campo obligatorio
            </span>
            <span *ngIf="getControl('fk_factura')?.hasError('maxlength')">
                Máximo {{getControl('fk_factura').getError('maxlength').requiredLength }} caracteres
            </span>
            <span *ngIf="getControl('fk_factura').hasError('pattern')">
                Formato inválido
            </span>
            <span *ngIf="getControl('fk_factura').hasError('email')">
                Correo inválido
            </span>
        </small>
    </div>
    -->

    <div class="field">
        <label for="factura">Factura:*</label>
        <select id="factura" formControlName="fk_factura"
            [ngClass]="{'input-error': getControl('fk_factura').touched && getControl('fk_factura').invalid}">
            <option value="" disabled selected>Seleccione una factura</option>
            <option *ngFor="let factura of facturas" [value]="factura.id">{{ factura.numero_factura }}</option>
        </select>

        <small class="error" *ngIf="getControl('fk_factura').touched && getControl('fk_factura').invalid">
            <span *ngIf="getControl('fk_factura')?.hasError('required')">
                Campo obligatorio
            </span>
        </small>
    </div>


    <!-- NOMBRE DEL PRODUCTO -->
    <div class="field">
        <label for="nom_producto">Nombre del producto:*</label>
        <input id="nom_producto" name="nom_producto" type="text" formControlName="nom_producto"
            [ngClass]="{'input-error':getControl('nom_producto').touched && getControl('nom_producto').invalid}" />
        <small class="error" *ngIf="getControl('nom_producto').touched && getControl('nom_producto').invalid">
            <span *ngIf="getControl('nom_producto')?.hasError('required')">
                Campo obligatorio
            </span>
            <span *ngIf="getControl('nom_producto')?.hasError('maxlength')">
                Máximo {{getControl('nom_producto').getError('maxlength').requiredLength }} caracteres
            </span>
            <span *ngIf="getControl('nom_producto').hasError('pattern')">
                Formato inválido
            </span>
            <span *ngIf="getControl('nom_producto').hasError('email')">
                Correo inválido
            </span>
        </small>
    </div>

    <!-- PRESENTACION -->
    <div class="field">
        <label for="lote">Presentacion:*</label>
        <input id="lote" name="lote" type="text" formControlName="presentacion"
            [ngClass]="{'input-error':getControl('presentacion').touched && getControl('presentacion').invalid}" />
        <small class="error" *ngIf="getControl('presentacion').touched && getControl('presentacion').invalid">
            <span *ngIf="getControl('presentacion')?.hasError('required')">
                Campo obligatorio
            </span>
            <span *ngIf="getControl('presentacion')?.hasError('maxlength')">
                Máximo {{getControl('presentacion').getError('maxlength').requiredLength }} caracteres
            </span>
            <span *ngIf="getControl('presentacion')?.hasError('pattern')">
                Formato inválido
            </span>
        </small>
    </div>

    <!-- FECHA CADUCIDAD-->
    <div class="field">
        <label for="fecha">Fecha de Caducidad:*</label>
        <input id="fecha" name="fecha" type="date" formControlName="fecha_caducidad"
            [ngClass]="{'input-error':getControl('fecha_caducidad').touched && getControl('fecha_caducidad').invalid}" />
        <small class="error" *ngIf="getControl('fecha_caducidad').touched && getControl('fecha_caducidad').invalid">
            <span *ngIf="getControl('fecha_caducidad')?.hasError('required')">
                Campo obligatorio
            </span>
        </small>
    </div>

    <!-- NOMBRE DE HOSPITAL -->
    <div class="field">
        <label for="hospital">Nombre del Hospital:*</label>
        <input id="hospital" name="hospital" type="text" formControlName="nombre_hospital"
            [ngClass]="{'input-error':getControl('nombre_hospital').touched && getControl('nombre_hospital').invalid}" />
        <small class="error" *ngIf="getControl('nombre_hospital').touched && getControl('nombre_hospital').invalid">
            <span *ngIf="getControl('nombre_hospital')?.hasError('required')">
                Campo obligatorio
            </span>
            <span *ngIf="getControl('nombre_hospital')?.hasError('maxlength')">
                Máximo {{getControl('nombre_hospital').getError('maxlength').requiredLength }} caracteres
            </span>
            <span *ngIf="getControl('nombre_hospital').hasError('pattern')">
                Formato inválido
            </span>
            <span *ngIf="getControl('nombre_hospital').hasError('email')">
                Correo inválido
            </span>
        </small>
    </div>

    <!-- NOMBRE DE MEDICO -->
    <div class="field">
        <label for="medico">Nombre del Medico:*</label>
        <input id="medico" name="medico" type="text" formControlName="nombre_medico"
            [ngClass]="{'input-error':getControl('nombre_medico').touched && getControl('nombre_medico').invalid}" />
        <small class="error" *ngIf="getControl('nombre_medico').touched && getControl('nombre_medico').invalid">
            <span *ngIf="getControl('nombre_medico')?.hasError('required')">
                Campo obligatorio
            </span>
            <span *ngIf="getControl('nombre_medico')?.hasError('maxlength')">
                Máximo {{getControl('nombre_medico').getError('maxlength').requiredLength }} caracteres
            </span>
            <span *ngIf="getControl('nombre_medico').hasError('pattern')">
                Formato inválido
            </span>
            <span *ngIf="getControl('nombre_medico').hasError('email')">
                Correo inválido
            </span>
        </small>
    </div>

    <!-- Botones -->
    <div class="buttons">
        <button type="button" class="btn btn-secondary" (click)="productoForm.reset()">
            Cancelar
        </button>
        <!--   
            <button type="button" class="btn btn-secondary" (click)="addCookie()">
                cookies
            </button>
        -->
        <button type="submit" class="btn btn-primary" [disabled]="productoForm.invalid">
            Guardar
        </button>
    </div>
</form>